import axios from 'axios';

async function claimTreats(txn) {
  if (!txn) {
    throw new Error('No txn provided');
  }

  await axios.post(
    '/api/cities/claim-treats',
    {
      txn,
    },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    }
  );
}

export default claimTreats;
